import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import Layout from '../components/Layout';

const NotFound = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-b from-[#2A382A] via-[#2A382A] to-[#1F2B1F] flex items-center justify-center px-4">
        <div className="max-w-2xl w-full text-center">
          {/* Logo */}
          <Link 
            to="/" 
            aria-label="Return to homepage"
            className="inline-flex items-center gap-3 mb-12"
          >
            <img src="/assets/logo-inversed-new.webp" alt="Sierpe Frogs" className="w-12 h-12" />
            <span className="font-barrio text-3xl">SIERPE FROGS</span>
          </Link>

          {/* 404 Text */}
          <h1 className="font-barrio text-[150px] leading-none text-[#953B0E] mb-8">
            404
          </h1>

          {/* Message */}
          <h2 className="text-3xl font-bold mb-4">Page Not Found</h2>
          <p className="text-white/70 mb-12 max-w-lg mx-auto">
            Oops! It seems like this page has hopped away. Don't worry though, you can still explore our other amazing adventures!
          </p>

          {/* Action Buttons */}
          <div className="flex justify-center">
            <button
              onClick={() => window.location.href = '/'}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-sm text-white rounded-xl hover:bg-white/20 transition-all duration-300"
            >
              <Home className="w-5 h-5" />
              Back to Home
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;